import Vue from "vue"
import axios from "axios"
import { MessageUtil } from "@cndinfo/cube-web-utils"
import moment from "moment"
import {
  getToken,
} from "./auth"
import analyticsInstance from "./analytics"
let loading
function startLoading() {
  const styleNode = document.createElement('style')
  styleNode.setAttribute('type', 'text/css')
  styleNode.innerHTML = `
    .el-loading-fullscreen-request{
        z-index:2147483584 !important;
    }
`
  // document.querySelector('head')?.appendChild(styleNode)
  loading = Vue.prototype.$loading({
    fullscreen: true,
    text: '',
    spinner: 'el-icon-loading',
    background: 'rgba(255, 255, 255, .5)',
    customClass: 'el-loading-fullscreen-request',
  })
}
function endLoading() {
  loading.close()
}

//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json"
  },
  transformRequest: [
    function (data) {
      // eslint-disable-next-line
      Date.prototype.toJSON = function () {
        const formatDate = moment(this).format("YYYY-MM-DD HH:mm:ss")
        return formatDate.replace(" ", "T")
      }
      if (data instanceof FormData) return data
      data = JSON.stringify(data)
      return data
    }
  ]
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    if (config && !config.noLoading) {
      showFullScreenLoading()
    }

    if (
      config.noRequestHeaders !== false &&
      localStorage.getItem("requestHeaders")
    ) {
      const requestHeaders = JSON.parse(localStorage.getItem("requestHeaders"))
      Object.keys(requestHeaders).forEach((key) => {
        config.headers[key] = requestHeaders[key]
      })
    }

    if (getToken()) {
      config.headers["Authorization"] = getToken()
    }
    if (config.type) {
      config.headers["Content-Type"] = config.type
    }
    return config
  },
  (error) => {
    console.log(error)
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    tryHideFullScreenLoading()
    const res = response.data
    let isRequestSuccess = true
    console.warn("response---1", res)
    if (res && res.code) {
      switch (res.code) {
        case "0000":
          break
        case "200":
          break
        default:
          isRequestSuccess = false
          MessageUtil.error(res.message)
      }
    } else {
      isRequestSuccess = true
    }
    const requestTime = moment(response.headers.date)
    const nowTime = moment(new Date())
    const differ = nowTime.diff(requestTime)
    try {
      analyticsInstance.collectApi({
        apiName: response.config.url,
        apiTimeCost: differ,
        isSuccess: isRequestSuccess ? "true" : "false"
      })
    } catch (e) {}
    return isRequestSuccess ? res : Promise.reject(res)
  },
  (error) => {
    tryHideFullScreenLoading()
    let isTimeOut = false
    if (error.toString().indexOf("timeout") > -1) {
      MessageUtil.warning("请求超时，请重试！")
      isTimeOut = true
    }
    if (isTimeOut && error.config) {
      // 因为超时不会有error.response 且 获取不到date 所以分别写
      try {
        const url = error.config.url
        analyticsInstance.collectApi({
          apiName: url,
          apiTimeCost: -1,
          isSuccess: "timeout"
        })
      } catch (e) {}
    }
    if (error.response) {
      try {
        const requestTime = moment(error.response.headers.date)
        const nowTime = moment(new Date())
        const differ = nowTime.diff(requestTime)
        analyticsInstance.collectApi({
          apiName: error.response ? error.response.config.url : "",
          apiTimeCost: differ,
          isSuccess: "false"
        })
      } catch (e) {
        console.log(e)
      }
      const statusRes = error.response.status
      const errRes = error.response.data
      if (errRes.message) {
        MessageUtil.warning(errRes.message)
        return
      }
      switch (statusRes) {
        case 400:
          MessageUtil.warning("客户端请求的语法错误，服务器无法理解")
          break
        case 401:
          MessageUtil.warning("Token已过期失效，请重新登录")
          break
        case 404:
          MessageUtil.warning("可能正在重启服务，请稍等！")
          break
        case 405:
          MessageUtil.warning("客户端请求中的方法被禁止")
          break
        case 500:
          MessageUtil.warning("服务器内部错误，无法完成请求")
          break
        case 502:
          MessageUtil.warning("从远程服务器接收到了一个无效的响应")
          break
        default:
          MessageUtil.warning(errRes.message)
          break
      }
    }
    return error
  }
)

export default service
